<fgb-banner [pageName]="'payment.page.title'"></fgb-banner>

<fgb-page-header [pageTitle]="'payment.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<fgb-payment-nav></fgb-payment-nav>

<router-outlet></router-outlet>
